import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import timezone from 'dayjs/plugin/timezone';

const DATE_FORMAT = 'MMM D, YYYY';
const DATETIME_FORMAT = `${DATE_FORMAT} HH:mm z`;
const DATETIME_FORMAT_COMPLETE = `${DATE_FORMAT} HH:mm:ss.SSS z`;
dayjs.extend(advancedFormat);
dayjs.extend(timezone);

const getDatePlusDays = (days: number) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date;
};

const getDefaultDeadline = () => {
  return getDatePlusDays(3).toISOString();
};

const getMinDeadline = () => {
  return getDatePlusDays(1).toString();
};

export const getFormattedDateString = (date: string, full = false) => {
  return dayjs(date).format(full ? DATETIME_FORMAT : DATE_FORMAT);
};

export const getFormattedDateCompleteString = (date: string) => {
  return dayjs(date).format(DATETIME_FORMAT_COMPLETE);
};

/**
 * Date Range inclusive limits
 */
export const formatDateRange = (dataRangeString?: string) => {
  const dates = (dataRangeString || '').split(' - ').map((dateString) => dateString.trim());
  if (dates.length == 2) {
    dates[0] = getFormattedDateCompleteString(dates[0] + ' 00:00:00');
    dates[1] = getFormattedDateCompleteString(dates[1] + ' 23:59:59.999');
  }
  return dates;
};

const isDeadlineValid = (deadline: string): boolean => {
  const minDeadline = new Date(getFormattedDateString(getMinDeadline()));
  const date = new Date(deadline);
  if (isNaN(date.getTime())) {
    return false;
  }
  return date > minDeadline;
};

const getEarliestDate = (dates: string[]): string | undefined => {
  if (dates.length === 0) return undefined;
  return dates.reduce((earliest, current) => {
    return new Date(current) < new Date(earliest) ? current : earliest;
  });
};

export const useGetDate = () => {
  return {
    getDatePlusDays,
    getDefaultDeadline,
    getMinDeadline,
    getFormattedDateString,
    isDeadlineValid,
    getEarliestDate
  };
};
